module.exports = __webpack_public_path__ + "media.e6f419ad437ecb05c71a.ttf";


//////////////////
// WEBPACK FOOTER
// C:/Users/INMOGR/Desktop/Angular Project/src/assets/fonts/line-icons-pro/media/webfont/media.ttf
// module id = ../../../../../src/assets/fonts/line-icons-pro/media/webfont/media.ttf
// module chunks = styles